<top-navig></top-navig>
<router-outlet></router-outlet>
<footer-component></footer-component>